import { Controller } from "@hotwired/stimulus";

// The menu item and the builder are in different Stimulus scopes, so bridge with a window event.
export default class extends Controller {
  start() {
    window.dispatchEvent(new CustomEvent("massimo:report-builder"));
  }
}
